var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"id":"pageTop"}}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('Analytics'),_vm._v(" "),_c('clear-session-storage')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }